"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickToPaySignIn = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var secure_fields_1 = require("@gr4vy/secure-fields");
var react_1 = require("react");
var use_secure_fields_1 = require("../../hooks/use-secure-fields");
var ClickToPaySignIn = function (_a) {
    var children = _a.children, _ = _a.id, style = _a.style, onVisibilityChange = _a.onVisibilityChange, rest = __rest(_a, ["children", "id", "style", "onVisibilityChange"]);
    var _b = (0, use_secure_fields_1.useSecureFields)(), clickToPay = _b.clickToPay, secureFields = _b.secureFields;
    (0, react_1.useLayoutEffect)(function () {
        if (!clickToPay)
            return;
        onVisibilityChange &&
            (secureFields === null || secureFields === void 0 ? void 0 : secureFields.addEventListener(secure_fields_1.SecureFields.Events.CLICK_TO_PAY_SIGN_IN_VISIBILITY_CHANGE, onVisibilityChange));
        return function () {
            onVisibilityChange &&
                (secureFields === null || secureFields === void 0 ? void 0 : secureFields.addEventListener(secure_fields_1.SecureFields.Events.CLICK_TO_PAY_SIGN_IN_VISIBILITY_CHANGE, onVisibilityChange));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clickToPay]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ id: "click-to-pay-sign-in", style: __assign({ display: 'none' }, style) }, rest, { children: children })));
};
exports.ClickToPaySignIn = ClickToPaySignIn;
//# sourceMappingURL=ClickToPaySignIn.js.map